document.addEventListener('DOMContentLoaded', () => {
  const footer = document.querySelector('th-footer');
  if (!footer) return;

  // Guard against double-binding: this plugin is loaded from multiple entry
  // points (plugins/index.js via client-side, and the mobile-a11y pack). On
  // layouts that include more than one of those, register the listener once.
  if (footer.dataset.localeChangeBound) return;
  footer.dataset.localeChangeBound = 'true';

  footer.addEventListener('locale_change', (e) => {
    window.location.href = `/locales/set?to_locale=${e.detail.value}`;
  });
});
